import { isEqual } from 'lodash/fp';

import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import {
  CaseTemplate,
  CaseTemplateBasicsOption,
  CaseTemplateStatus,
} from 'dashboard/models/case-template';
import {
  CaseTemplatesActions,
  CaseTemplatesActionType,
  CaseTemplatesFilterParams,
} from 'dashboard/redux/actions/case-templates';

export const initialCaseTemplatesFilterState: CaseTemplatesFilterParams = {
  createdAtStart: undefined,
  createdAtEnd: undefined,
  omni: undefined,
  status: [CaseTemplateStatus.Active],
};

export interface CaseTemplatesState extends TableState<CaseTemplatesFilterParams> {
  caseTemplates: CaseTemplate[];
  basicsOptions: CaseTemplateBasicsOption[];
  atActiveCaseTemplateLimit: boolean;
}

export const initialCaseTemplatesState: CaseTemplatesState = {
  caseTemplates: [],
  basicsOptions: [],
  filters: initialCaseTemplatesFilterState,
  sortParams: {
    sort: 'updated_at',
    shouldSortDescending: true,
  },
  paginationParams: undefined,
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
  atActiveCaseTemplateLimit: true,
};

export default (
  state: CaseTemplatesState = initialCaseTemplatesState,
  action: CaseTemplatesActions,
) => {
  switch (action.type) {
    case CaseTemplatesActionType.SetCaseTemplates: {
      return {
        ...state,
        caseTemplates: action.payload.caseTemplates,
        paginationParams: action.payload.paginationParams,
        atActiveCaseTemplateLimit: action.payload.atActiveCaseTemplateLimit,
      };
    }

    case CaseTemplatesActionType.SetCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }

    case CaseTemplatesActionType.SetPageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }

    case CaseTemplatesActionType.SetFilters: {
      const newFilters = {
        ...state.filters,
        ...action.payload.filters,
      };

      if (isEqual(newFilters, state.filters)) {
        return state;
      } else {
        return {
          ...state,
          filters: newFilters,
        };
      }
    }

    case CaseTemplatesActionType.SetBasicsOptions: {
      return {
        ...state,
        basicsOptions: action.payload.basicsOptions,
      };
    }

    case CaseTemplatesActionType.SetSortParams: {
      return {
        ...state,
        sortParams: {
          ...state.sortParams,
          ...action.payload.sortParams,
        },
      };
    }

    default:
      return state;
  }
};
